/* MADERO — kleine Text-Overrides für App-Widgets (nicht via App-Admin änderbar) */
(function () {
  'use strict';

  /* Appointo/Servicify-Buchungsmodal: Label "Optionen" -> "Standort" (Kunde, 14.07.) */
  function relabel() {
    var rows = document.querySelectorAll('.servicify-filter-row div, .ReactModal__Content div');
    for (var i = 0; i < rows.length; i++) {
      var el = rows[i];
      if (el.children.length === 0 && el.textContent.trim() === 'Optionen') {
        el.textContent = 'Standort';
      }
    }
  }

  var observer = new MutationObserver(relabel);

  function start() {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
    relabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Autoplay-Videos (Kurs-Teaser) erst starten, wenn sie sichtbar sind.
     Chrome verzoegert Autoplay bei Videos weit unten sonst dauerhaft. 21.08.2026 */
  (function () {
    function wire() {
      var vids = document.querySelectorAll('video[autoplay][muted], video.mv4-trio__video, video.mv4-vsplit__video');
      if (!vids.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {
              /* Autoplay blockiert (z.B. iOS Stromsparmodus): Bedienelemente zeigen,
                 damit die Besucherin das Video antippen kann statt ein Standbild zu sehen. */
              v.setAttribute('controls', '');
            });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wire);
    } else {
      wire();
    }
  })();

})();

/* Lorien 16.10.2026 M-K1: Kursbuchung über die Kasse.
   Schaltet sich je Kurs selbst ein, sobald der Kurs in der Buchungs-App «Einfache Terminbuchung» (Servicify)
   auf Bezahlbuchung steht: Event mit canBookWithoutCheckout=false, gelesen über dieselbe öffentliche Schnittstelle,
   die das Widget der App auf jeder Kursseite lädt (nur Produkt-ID, keine Cookies, keine Personendaten).
   Dann gilt für diesen Kurs:
   - Kursseite: die Sticky-Leiste öffnet den Buchungsdialog statt den Kurs ohne Termin in den Warenkorb zu legen
     (Ä6 vom 03.10.2026), Menge und «Mit Shop kaufen» in der Leiste aus, das 10-Prozent-Fenster bleibt zu (Ä7).
   - Kurskarten (Kollektion, Suche, Empfehlungen): der Knopf führt auf die Kursseite statt in den Warenkorb.
   Solange ein Kurs auf Gratisreservierung steht, bleibt für ihn alles wie bisher.
   Test ohne Umstellung: ?mv5_kasse=1 erzwingt den Modus für diesen Seitenaufruf. */
(function () {
  'use strict';
  var API = 'https://servicify-appointments.herokuapp.com/api/products/';
  var ZWANG = /[?&]mv5_kasse=1(&|$)/.test(location.search);
  var TEXT = 'Datum wählen';
  var html = document.documentElement;
  var laufend = {};
  function modus(pid) {
    pid = String(pid || '');
    if (!pid) return Promise.resolve(false);
    if (ZWANG) return Promise.resolve(true);
    if (laufend[pid]) return laufend[pid];
    var k = 'mv5-kasse-' + pid;
    try {
      var c = JSON.parse(sessionStorage.getItem(k) || 'null');
      if (c && c.t > Date.now() - 900000) return (laufend[pid] = Promise.resolve(!!c.an));
    } catch (e) {}
    if (!window.fetch) return Promise.resolve(false);
    laufend[pid] = fetch(API + pid + '/allEvents', { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (ev) {
        var an = Array.isArray(ev) && ev.some(function (e) { return e && e.isActive !== false && e.canBookWithoutCheckout === false; });
        try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), an: an })); } catch (e) {}
        return an;
      })
      .catch(function () { return false; });
    return laufend[pid];
  }
  function dialogOeffnen() {
    var b = document.querySelector('button[class*="servicify"]:not([data-mv5-oeffnen])');
    if (b) { b.click(); return; }
    var c = document.getElementById('servicify-app-embed-container') || document.querySelector('[data-mv5-kurstermine]');
    if (c && c.scrollIntoView) c.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function aufKursseite(an) {
    if (!an) return;
    html.classList.add('mv5-kasse');
    var st = document.createElement('style');
    st.textContent = 'html.mv5-kasse #maderoPopup,html.mv5-kasse #maderoPopupOverlay{display:none!important}'
      + 'html.mv5-kasse [data-sticky-add-to-cart] .productView-groupBottom,'
      + 'html.mv5-kasse [data-sticky-add-to-cart] .quantity__group{display:none!important}'
      + '@media (min-width:768px){html.mv5-kasse [data-sticky-add-to-cart] #product-sticky-add-to-cart{width:auto!important;min-width:160px;padding-left:24px;padding-right:24px;white-space:nowrap;text-overflow:clip}}';
    document.head.appendChild(st);
    ['show-sticky-product', 'product-sticky-add-to-cart'].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.textContent = TEXT;
    });
    var popup = document.getElementById('maderoPopup');
    function zu() {
      if (!popup || !popup.classList.contains('is-visible')) return;
      popup.classList.remove('is-visible');
      var o = document.getElementById('maderoPopupOverlay');
      if (o) o.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
    if (popup && window.MutationObserver) { zu(); new MutationObserver(zu).observe(popup, { attributes: true, attributeFilter: ['class'] }); }
  }
  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
  if (meta && /kurs/i.test(meta.type || '') && meta.id) modus(meta.id).then(aufKursseite);

  function zurKursseite(f) { location.href = f.getAttribute('data-mv5-kurs-url'); }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (html.classList.contains('mv5-kasse') && t.closest('#show-sticky-product, [data-sticky-add-to-cart] button[name="add"]')) {
      e.preventDefault(); e.stopImmediatePropagation(); dialogOeffnen(); return;
    }
    var f = t.closest('form.mv5-kasse-karte');
    if (f && t.closest('button, [data-btn-addtocart]')) { e.preventDefault(); e.stopImmediatePropagation(); zurKursseite(f); }
  }, true);
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest) return;
    if (html.classList.contains('mv5-kasse') && f.closest('[data-sticky-add-to-cart]')) { e.preventDefault(); e.stopImmediatePropagation(); dialogOeffnen(); return; }
    if (f.classList && f.classList.contains('mv5-kasse-karte')) { e.preventDefault(); e.stopImmediatePropagation(); zurKursseite(f); }
  }, true);

  function karten() {
    var liste = document.querySelectorAll('form[data-mv5-kurs-url]:not([data-mv5-geprueft])');
    Array.prototype.forEach.call(liste, function (f) {
      f.setAttribute('data-mv5-geprueft', '1');
      modus(f.getAttribute('data-product-id')).then(function (an) {
        if (!an) return;
        f.classList.add('mv5-kasse-karte');
        Array.prototype.forEach.call(f.querySelectorAll('button[name="add"]'), function (b) { b.textContent = TEXT; });
      });
    });
  }
  function start() {
    karten();
    if (window.MutationObserver) {
      var warte;
      new MutationObserver(function () { clearTimeout(warte); warte = setTimeout(karten, 300); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
